import { render } from "./FormSectionAlternative.vue?vue&type=template&id=0a3b72c0"
import script from "./FormSectionAlternative.vue?vue&type=script&lang=js"
export * from "./FormSectionAlternative.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/prod/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__